import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { BookableExperienceAvailabilityItem, ItemsState } from "./types";

import { RootState } from "lib/store";

const initialState: ItemsState = {
  items: [],
  isLoading: false,
  error: "",
};

// Slice
export const itemsSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    setItems(
      state: ItemsState,
      action: PayloadAction<BookableExperienceAvailabilityItem[]>
    ) {
      state.items = action.payload;
    },
    setItemsLoading(state: ItemsState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setItemsError(state: ItemsState, action: PayloadAction<string>) {
      state.error = action.payload;
    },
  },
});

const selectSlice = (state: RootState) => state.itemsSlice || initialState;

export const selectItems = createSelector(
  [selectSlice],
  (state: ItemsState) => state.items
);

export const { setItems, setItemsError, setItemsLoading } = itemsSlice.actions;

export default itemsSlice.reducer;
